const KNOWN_SYSTEM_FILE_NAMES = new Set(['.DS_Store', '.Spotlight-V100', '.Trashes', '.fseventsd', 'Thumbs.db', 'desktop.ini', 'ehthumbs.db']);
export const isSystemEntry = entry => {
  return KNOWN_SYSTEM_FILE_NAMES.has(entry.name);
};
export const isSystemFile = file => {
  return KNOWN_SYSTEM_FILE_NAMES.has(file.name);
};